import { Link } from 'react-router';
import { FOOTER_COLUMNS, hrefOf } from './navLinks';

/**
 * Footer — the COMPOSED result of five blocks (base :558 + v2/v3/v11/v12/v13),
 * 23 links. See navLinks.ts for the per-link provenance and the spec's
 * "48 links" discrepancy.
 *
 * Every link carries a real destination declared at source. The prototype had
 * ten with no handler at all, repaired only at v21 by matching link TEXT and
 * patching the DOM afterwards (:6584) — which breaks silently the moment a
 * label is reworded.
 */
export function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="foot-grid">
          <div>
            <div className="logo" style={{ color: '#fff', marginBottom: 12 }}>
              <span className="logo-mark">◆</span>MAKTech Academy
            </div>
            <p style={{ fontSize: 13.5, maxWidth: 280 }}>
              Learn in-demand skills with live and recorded classes, hands-on projects, and verified
              certificates.
            </p>
          </div>

          {FOOTER_COLUMNS.map((col) => (
            <div key={col.heading}>
              <h4>{col.heading}</h4>
              {col.links.map((l) => (
                <Link
                  key={l.label}
                  to={hrefOf(l.target)}
                  data-testid={`foot-link-${l.label}`}
                  data-pending={l.target.kind !== 'route' ? String(l.target.pendingPhase) : undefined}
                >
                  {l.label}
                </Link>
              ))}
            </div>
          ))}
        </div>
        {/* Payment trust strip — injectV3 (:2195), before foot-bottom. */}
        <div className="pay-strip">
          <span style={{ fontSize: 12, color: '#8C8C8C' }}>We accept:</span>
          <span className="pay-chip">bKash</span>
          <span className="pay-chip">Nagad</span>
          <span className="pay-chip">Rocket</span>
          <span className="pay-chip">VISA</span>
          <span className="pay-chip">Mastercard</span>
          <span className="pay-chip">AMEX</span>
          <span className="pay-chip">PayPal</span>
          <span style={{ fontSize: 12, color: '#8C8C8C', marginLeft: 'auto' }}>🔒 SSL secure checkout · 30-day money-back guarantee</span>
        </div>
        <div className="foot-bottom">
          <span>© 2026 MAKTech Academy. All rights reserved.</span>
          <span>Demo prototype — for review only</span>
        </div>
      </div>
    </footer>
  );
}
